function hideBtnMenu() {
    var footer = document.getElementById('footer');
    var btn = document.getElementById('menu-btn');
    var coordinate = footer.getBoundingClientRect();
    var footerY = coordinate.y;
    var windowHeight = window.innerHeight;
    if ( footerY < windowHeight ) {
        btn.classList.add('menu-btn-hidden')
    } else if ( footerY >= windowHeight )  {
        btn.classList.remove('menu-btn-hidden')
    }
};

window.addEventListener('scroll', hideBtnMenu);